export default "__VITE_ASSET__Lid4uKTV__"